
import polyfillLoader from '@/common/polyfills/InitPolyfills';

import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import PortalVue from 'portal-vue';
import SvgIcon from 'vue-svgicon';
import { directive as onClickaway } from 'vue-clickaway';
import VueMq from 'vue-mq'
import VueAnimateNumber from 'vue-animate-number';
import AsyncComputed from 'vue-async-computed';
import VueScrollTo from 'vue-scrollto';
import Tooltip from 'vue-directive-tooltip';

import { ApiService } from '@/api';
import IntrotextElement from '@/components/elements/IntrotextElement.vue';
import MediaElement from '@/components/elements/MediaElement.vue';
import ButtonElement from '@/components/elements/ButtonElement.vue';
import NuggetDetail from '@/views/NuggetDetail.vue';
import PageView from '@/views/PageView.vue';
import GeneralEntryView from '@/views/GeneralEntryView.vue';
import KnowledgeTest from '@/views/KnowledgeTest.vue';
import App from '@/App.vue';

import '@/_icons';


Vue.use(SvgIcon, { tagName: 'svgicon' });
Vue.use(PortalVue);
Vue.use(Tooltip);
Vue.use(VueScrollTo);
Vue.use(AsyncComputed);
Vue.use(VueAnimateNumber);

Vue.use(VueMq, {
    breakpoints: {
        sm: 768,
        md: 1024,
        lg: Infinity,
    }
});

Vue.component('nugget-detail', NuggetDetail);
Vue.component('page-view', PageView);
Vue.component('general-entry-view', GeneralEntryView);
Vue.component('knowledge-test', KnowledgeTest);
Vue.component('introtext-element', IntrotextElement);
Vue.component('media-element', MediaElement);
Vue.component('button-element', ButtonElement);
Vue.component('app', App);

Vue.directive('click-away', onClickaway);

Vue.directive('expand', {
    inserted: function(el, binding) {

        if (binding.value !== null) {

            function calcHeight() {
                const currentState = el.getAttribute('aria-expanded')

                el.classList.add('u-no-transition')
                el.removeAttribute('aria-expanded')
                el.style.height = null
                el.style.height = el.clientHeight + 'px'
                el.setAttribute('aria-expanded', currentState)

                setTimeout(function() {
                    el.classList.remove('u-no-transition')
                })
            }

            el.classList.add('expand')
            el.setAttribute('aria-expanded', (binding.value) ? 'true' : 'false');

            calcHeight();

            window.addEventListener('resize', calcHeight);
        }
    },
    update: function(el, binding) {
        if (el.style.height && binding.value !== null) {
            el.setAttribute('aria-expanded', (binding.value) ? 'true' : 'false')
        }
    },
});

ApiService.init();

new Vue({
    el: '#app',
    router,
    store,
    async mounted() {
        polyfillLoader();
    }
});
